import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    country: null,
    examboard: null,
    subject: null,
    year: null,
    chapter: null,
  },
  formData: null,
};

export const worksheetSlice = createSlice({
  name: "worksheet",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFilter, setFormData } = worksheetSlice.actions;

export default worksheetSlice.reducer;
